import { CDN_ROOT, getCdnImageUrl } from "../features/images";
import { Gender } from "./gender";
import { Goals } from "./goals";
import { loc } from "../i18n/survey";
import { locFormat } from "./utils";

enum BodyFat {
  Ten = 10,
  Twelve = 12,
  Fifteen = 15,
  Eighteen = 18,
  Twenty = 20,
  TwentyFive = 25,
  Thirty = 30,
  ThirtyFive = 35,
  Fourty = 40,
  OverFourtyFive = 45,
}

const bodyFatQuestion = {
  name: "bodyFat",
  title: "Which image best reflects your <div class='highlight'>current body fat</div> level?",
  description: "It doesn’t need to be exact, just choose the one that feels closest.",
  type: "imagepicker",
  showLabel: true,
  isRequired: true,
  colCount: 0,
}

const bodyFatMaleQuestion = {
  ...bodyFatQuestion,
  visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
  choices: [
    {
      "value": BodyFat.ThirtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male35.jpg`,
      "text": "35% and above",
    },
    {
      "value": BodyFat.Thirty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male30.jpg`,
      "text": "Around 30%",
    },
    {
      "value": BodyFat.TwentyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male25.jpg`,
      "text": "Around 25%",
    },
    {
      "value": BodyFat.Twenty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male20.jpg`,
      "text": "Around 20%",
    },
    {
      "value": BodyFat.Fifteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male15.jpg`,
      "text": "Around 15%",
    },
    {
      "value": BodyFat.Twelve,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male12.jpg`,
      "text": "Around 12%",
    },
    {
      "value": BodyFat.Ten,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male10.jpg`,
      "text": "Around 10%",
      visibleIf: `{goals} != "${Goals.BuildMuscleAndLoseFat}"`
    },
  ],
};

const bodyFatFemaleQuestion = {
  ...bodyFatQuestion,
  visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
  choices: [
    {
      "value": BodyFat.OverFourtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female45.jpg`,
      "text": "45% and above",
    },
    {
      "value": BodyFat.Fourty,
      "imageLink": getCdnImageUrl("images/bodyfat/female40.jpg"),
      "text": "Around 40%",
    },
    {
      "value": BodyFat.ThirtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female35.jpg`,
      "text": "Around 35%",
    },
    {
      "value": BodyFat.Thirty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female30.jpg`,
      "text": "Around 30%",
    },
    {
      "value": BodyFat.TwentyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female25.jpg`,
      "text": "Around 25%",
    },
    {
      "value": BodyFat.Twenty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female20.jpg`,
      "text": "Around 20%",
    },
    {
      "value": BodyFat.Eighteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female18.jpg`,
      "text": "Around 18%",
    },
    {
      "value": BodyFat.Fifteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female15.jpg`,
      "text": "Around 15%",
    },
  ],
};

const bodyFatBothQuestion = {
  ...bodyFatQuestion,
  choices: [
    {
      "value": BodyFat.ThirtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male35.jpg`,
      "text": "35% and above",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.Thirty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male30.jpg`,
      "text": "Around 30%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.TwentyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male25.jpg`,
      "text": "Around 25%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.Twenty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male20.jpg`,
      "text": "Around 20%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.Fifteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male15.jpg`,
      "text": "Around 15%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.Twelve,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male12.jpg`,
      "text": "Around 12%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      "value": BodyFat.Ten,
      "imageLink": `${CDN_ROOT}/images/bodyfat/male10.jpg`,
      "text": "Around 10%",
      visibleIf: `{goals} != "${Goals.BuildMuscleAndLoseFat} && {gender} = "${Gender.Male} "`
    },
    {
      "value": BodyFat.OverFourtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female45.jpg`,
      "text": "45% and above",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.Fourty,
      "imageLink": getCdnImageUrl("images/bodyfat/female40.jpg"),
      "text": "Around 40%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.ThirtyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female35.jpg`,
      "text": "Around 35%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.Thirty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female30.jpg`,
      "text": "Around 30%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.TwentyFive,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female25.jpg`,
      "text": "Around 25%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.Twenty,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female20.jpg`,
      "text": "Around 20%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.Eighteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female18.jpg`,
      "text": "Around 18%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      "value": BodyFat.Fifteen,
      "imageLink": `${CDN_ROOT}/images/bodyfat/female15.jpg`,
      "text": "Around 15%",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
  ],
};

const bodyFatCarouselQuestion = {
  name: "bodyFat",
  title: loc("quiz.bodyFat.title"),
  description: loc("quiz.bodyFat.description"),
  type: "carousel",
  isRequired: true,
  choices: [
    {
      value: BodyFat.ThirtyFive,
      imageUrl: `${CDN_ROOT}/images/bodyfat/male35.jpg`,
      text: "35% +",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.Thirty,
      imageUrl: `${CDN_ROOT}/images/bodyfat/male30.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 30 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.TwentyFive,
      imageUrl: `${CDN_ROOT}/images/bodyfat/male25.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 25 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.Twenty,
      imageUrl: `${CDN_ROOT}/images/bodyfat/male20.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 20 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.Fifteen,
      imageUrl: `${CDN_ROOT}/images/bodyfat/goalMale15.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 15 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.Twelve,
      imageUrl: `${CDN_ROOT}/images/bodyfat/goalMale12.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 12 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Male}"`,
    },
    {
      value: BodyFat.Ten,
      imageUrl: `${CDN_ROOT}/images/bodyfat/goalMale10.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 10 }),
      visibleIf: `{goals} != "${Goals.BuildMuscleAndLoseFat} && {gender} = "${Gender.Male} "`
    },
    {
      value: BodyFat.OverFourtyFive,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female45.jpg`,
      text: "45% +",
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.Fourty,
      imageUrl: getCdnImageUrl("images/bodyfat/female40.jpg"),
      text: locFormat("quiz.bodyFat.around", { percent: 40 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.ThirtyFive,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female35.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 35 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.Thirty,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female30.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 30 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.TwentyFive,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female25.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 25 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.Twenty,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female20.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 20 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.Eighteen,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female18.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 18 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
    {
      value: BodyFat.Fifteen,
      imageUrl: `${CDN_ROOT}/images/bodyfat/female15.jpg`,
      text: locFormat("quiz.bodyFat.around", { percent: 15 }),
      visibleIf: `getGender({gender},{physiology}) = "${Gender.Female}"`,
    },
  ],
};
export { BodyFat, bodyFatFemaleQuestion, bodyFatMaleQuestion,bodyFatBothQuestion, bodyFatCarouselQuestion };
